import { capitalizeAll, formatDate } from '@btime/helpers'
import { compose, path, prop } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useForm } from '../_load/FormLoader'
import { useFormReply } from '../_load/FormReplyLoader'
import Separator from '../../../../components/pdf/Separator'
import Text from '../../../../components/pdf/Text'

const PdfHeader = () => {
  const { t } = useTranslation('common')
  const form = useForm()
  const formReply = useFormReply()

  const title = form.name
  const placeName = compose(capitalizeAll, path(['place', 'name']))(formReply)
  const placeResume = compose(capitalizeAll, path(['place', 'resume']))(formReply)
  const executedAt = compose(formatDate('DD/MM/YYYY'), prop('insertedAt'))(formReply)

  return (
    <div>
      <Separator weight={4} />
      <Text size="h2" bold>
        {title}
      </Text>
      <Separator weight={1} />
      {placeName && (
        <Text size="h6">
          {placeResume} - {placeName}
        </Text>
      )}
      <Separator weight={4} />
      <Text size="small" bold>
        {t('pdf.repliedAt', { date: executedAt })}
      </Text>

      <Separator weight={8} />
    </div>
  )
}

export default PdfHeader
